import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import PortalModal from 'components/Shared/PortalModal'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

export default function AutoPromptModal({ isOpen, onClose, onAccept }) {
  const { t } = useTranslation()

  return (
    <PortalModal isOpen={isOpen} onClickOutside={onClose}>
      <div className="test-campaigns_auto-prompt yes-no-prompt">
        <div className="yes-no-prompt_content">
          <h1>{t('Settings.MetaAccess.TestCampaign.autoPrompt.title', 'Create Test Campaign?')}</h1>
          <p className="test-campaigns_auto-prompt_message">
            {t(
              'Settings.MetaAccess.TestCampaign.autoPrompt.message',
              'Would you like to create a test campaign with your newly connected assets?',
            )}
          </p>
          <div className="my-4 text-left">
            <strong>{t('Settings.MetaAccess.TestCampaign.autoPrompt.whatYouWillDo')}</strong>
            <ul style={{ listStyleType: 'disc' }} className="mt-2 ml-3">
              <li>
                {t(
                  'Settings.MetaAccess.TestCampaign.autoPrompt.step1',
                  'Select the Meta assets to use',
                )}
              </li>
              <li>
                {t(
                  'Settings.MetaAccess.TestCampaign.autoPrompt.step2',
                  'Publish a test campaign with a small budget',
                )}
              </li>
              <li>
                {t(
                  'Settings.MetaAccess.TestCampaign.autoPrompt.step3',
                  'Confirm events are received via Pixel/CAPI',
                )}
              </li>
            </ul>
          </div>
        </div>

        <div className="yes-no-prompt_footer">
          <TransparentBgButton
            text={t('Settings.MetaAccess.TestCampaign.autoPrompt.notNow', 'Not Now')}
            onClick={onClose}
            color="navy"
          />

          <SecondaryButton
            className="bt"
            text={t('Settings.MetaAccess.TestCampaign.autoPrompt.yesCreate', 'Yes, Create Test')}
            fullWidth={false}
            onClick={onAccept}
          />
        </div>
      </div>
    </PortalModal>
  )
}

AutoPromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
}
